import React from 'react';
import styled from '@emotion/styled';

const Message = styled.p`
  border-radius: 10px;
  background-color: hsla(0, 69%, 50%, 0.75);
  padding: 1rem;
  font-size: 30px;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  font-family: "bebas Neue", cursive;
`;

const Error = ({message}) => {
    return ( 
        <Message>{message}</Message>
     );
}
 
export default Error;